"use client";
import ProductDto from '@/projectRoot/api-client/interfaces/models/products/Product.dto';
import Container from '../../common/general/container/Container';
import Product from '../../common/product/Product';
import style from './productsSection.module.scss';
import Button from '../../common/form-elements/button/Button';
import Chevron from '../../common/svg/Chevron';
import { useCallback, useEffect, useRef, useState } from 'react';
import LinkUrl from '../../common/general/link/LinkUrl';
import { useApiClient } from '@/projectRoot/src/contexts/ApiClientContext';
import FiltersSectionDto from '@/projectRoot/api-client/interfaces/models/content/sitemap/blocks/FiltersSection.dto';

interface Props {
    wrappElement?: 'section' | 'div';
    products?: ProductDto[];
    section?: FiltersSectionDto;
}

const ProductsSection = ({wrappElement: WrapperTag = 'section', section}: Props) => {
    const {apiClient} = useApiClient();
    const [products, setProducts] = useState<ProductDto[]>();

    const getProducts = useCallback(async () => {
        try{
            const response = await apiClient.products().search(section ? {...section.filters, group_master: 1} : {group_master: 1});
            if(response.data){
                setProducts(response.data);
            }
        }catch(err){
            console.log(err);
        }
    }, [section]);

    //     {
    //         title: 'Prod 1',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_1',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '/sr/products/prod_1_id',
    //             en: '/en/products/prod_1_id'
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 2',
    //                 id: 'prod_2',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     sr: '/sr/products/prod_1_id',
    //                     en: '/en/products/prod_1_id'
    //                 },
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Prod 2',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_2',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '/sr/products/prod_1_id',
    //             en: '/en/products/prod_1_id'
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 3',
    //                 id: 'prod_3',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     sr: '/sr/products/prod_1_id',
    //                     en: '/en/products/prod_1_id'
    //                 },
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Prod 3',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_3',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '/sr/products/prod_1_id',
    //             en: '/en/products/prod_1_id'
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 4',
    //                 id: 'prod_4',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     sr: '/sr/products/prod_1_id',
    //                     en: '/en/products/prod_1_id'
    //                 },
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Prod 4',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_4',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '/sr/products/prod_1_id',
    //                 en: '/en/products/prod_1_id'
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '/sr/products/prod_1_id',
    //             en: '/en/products/prod_1_id'
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 5',
    //                 id: 'prod_5',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     sr: '/sr/products/prod_1_id',
    //                     en: '/en/products/prod_1_id'
    //                 },
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Prod 6',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_6',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '',
    //             en: ''
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 7',
    //                 id: 'prod_7',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     en: '',
    //                     sr: ''
    //                 },
    //             }
    //         ]
    //     },
    //     {
    //         title: 'Prod 8',
    //         base_price: 4440.00,
    //         price: 4440.00,
    //         id: 'prod_8',
    //         seo_slug: '',
    //         seo_title: '',
    //         labels: [
    //             {
    //                 id: 'prod_label_1',
    //                 visible_on_store_front: 1,
    //                 seo_title: '',
    //                 seo_slug: '',
    //                 title: 'Novo',
    //                 color_hex: 'blue',
    //                 multilang_slugs: {
    //                     sr: '',
    //                     en: ''
    //                 },
    //             }
    //         ],
    //         brand: {
    //             id: 'prod_brand_1',
    //             visible_on_store_front: 1,
    //             seo_title: '',
    //             seo_slug: '',
    //             title: 'Brand 1',
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category: {
    //             id: 'prod_category_1',
    //             ancestor_ids: [],
    //             parent_id: '',
    //             seo_slug: '',
    //             seo_title: '',
    //             title: 'Category 1',
    //             visible_on_store_front: 1,
    //             multilang_slugs: {
    //                 sr: '',
    //                 en: ''
    //             },
    //         },
    //         category_ancestors_ids: [],
    //         color: {
    //             id: 'prod_color_1',
    //             template: ColorTemplates.WHITE,
    //             title: 'White',
    //             visible_on_store_front: 1,
    //             color_hex: '#ffffff'
    //         },
    //         images: [
    //             '/storage/file-manager/content/sitemap/stock-image-travel.jpg',
    //             '/storage/file-manager/content/sitemap/stock-sports.jpg',
    //             '/storage/file-manager/content/sitemap/stock-party.jpg'
    //         ],
    //         multilang_slugs: {
    //             sr: '',
    //             en: ''
    //         },
    //         stock_variants: [
    //             {
    //                 stock_variant: 'M',
    //                 stock_count: 7
    //             },
    //             {
    //                 stock_variant: 'S',
    //                 stock_count: 1
    //             },
    //             {
    //                 stock_variant: 'L',
    //                 stock_count: 3
    //             }
    //         ],
    //         grouped_products: [
    //             {
    //                 title: 'Prod 9',
    //                 id: 'prod_9',
    //                 color: {
    //                     id: 'prod_color_2',
    //                     template: ColorTemplates.BLACK,
    //                     title: 'Black',
    //                     visible_on_store_front: 1,
    //                     color_hex: '#000000'
    //                 },
    //                 multilang_slugs: {
    //                     en: '',
    //                     sr: ''
    //                 },
    //             }
    //         ]
    //     },
    // ]; 
    const productsWrapper = useRef<HTMLDivElement | null>(null);
    const [disableArrow, setDisableArrow] = useState<{left: boolean, right: boolean}>({left: true, right: false});

    const moveSection = (move: 'left' | 'right') => {
        if(disableArrow[move]) return;
        if(productsWrapper){
            let movement: number = 0;
            // movement = (productsWrapper.current.firstChild as HTMLDivElement).clientWidth;
            movement = productsWrapper.current.offsetWidth;
            productsWrapper.current.scrollLeft = move == 'left' ? (productsWrapper.current.scrollLeft - movement) : (productsWrapper.current.scrollLeft + movement);
        }
    }

    useEffect(() => {
        if(productsWrapper && products && products.length > 0){
            productsWrapper.current.addEventListener('scroll', () => {
                setDisableArrow({
                    left: productsWrapper.current.scrollLeft == 0,
                    right: productsWrapper.current.scrollWidth - productsWrapper.current.offsetWidth <= productsWrapper.current.scrollLeft
                });
            });
            // return () => {
            //     productsWrapper.current.removeEventListener('scroll', () => {
            //         setDisableArrow({
            //             left: productsWrapper.current.scrollLeft == 0,
            //             right: productsWrapper.current.scrollWidth - productsWrapper.current.offsetWidth <= productsWrapper.current.scrollLeft
            //         });
            //     });
            // }
           
        }
    }, [productsWrapper, products]);

    useEffect(() => {
        getProducts();
    }, [section]);

  return (
    <WrapperTag className={style.productsSection}>
        <Container fluid classes={[style.container, false ? style.withImage : '']}>
            {/* <figure className={style.image}>
                <CubesImage imageNarrow='/storage/file-manager/content/sitemap/stock-image-travel.jpg' alt='' />
            </figure> */}
            <div className={style.sectionInner}>
                <div className={style.sectionTextInfo}>
                    {/* <p className={style.intro}>
                        Shop the look
                    </p> */}
                    <h2 className={style.title}>
                       {section?.title ?? 'New arrivals'}
                    </h2>
                    {
                        section?.call_to_action_url
                        ?
                        <LinkUrl url={section.call_to_action_url} text={section.call_to_action_text} classes={[style.link]} />
                        : <></>
                    }
                </div>
                {
                    products && products.length > 0
                    ?
                    <div className={style.outerWrapper}>
                        <div className={style.wrapper} ref={productsWrapper}>
                            {
                                products.map(product => 
                                    <Product key={product.id} classes={[style.product]} product={product} />
                                )
                            }
                        </div>
                        <Button label='chevron' classes={[style.arrow, disableArrow.left ? style.disabled : '']} onClick={() => moveSection('left')}>
                            <Chevron />
                        </Button>
                        <Button label='chevron' classes={[style.arrow, disableArrow.right ? style.disabled : '']} onClick={() => moveSection('right')}>
                            <Chevron />
                        </Button>

                    </div>
                    : <></>
                }
            </div>
        </Container>
    </WrapperTag>
  )
};

export default ProductsSection;
